<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em; padding-top:15px;">The author attended both Oxford and Cambridge (Football matches).</p>
<p style="text-indent:00em; padding-top:15px;">He received unnoticed critical acclaim for putting the ‘Ding’ into reading, the ‘Sex’ into Middlesex and something into Scunthorpe. His ambition is to take the ‘Woke’ out of Wokingham.</p>
<p style="text-indent:00em; padding-top:15px;">He currently lives somewhere. He drinks, eats and smokes too much, is overweight and is rather curmudgeonly.</p>
<p style="text-indent:00em;">He has reached that point in life when everything annoys him.</p>
<p style="text-indent:00em; padding-top:15px;">He does not support a football team and has no slippers.</p>
<p style="text-indent:00em; ">Quite frankly, he just doesn’t care whether you buy the book or not. He doesn’t need the money.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?bf03faf2